var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7641 17.2745C26.857 17.4612 25.9215 17.567 24.9592 17.567C17.1076 17.567 10.7434 11.2022 10.7434 3.35046C10.7434 2.38815 10.8492 1.45244 11.0357 0.5454C11.1033 0.214753 10.8039 -0.0810051 10.4821 0.0201625C4.23852 1.9804 -0.153946 8.11357 0.612118 15.1616C1.32301 21.692 6.61759 26.9871 13.148 27.6981C20.1954 28.4658 26.3298 24.072 28.2907 17.8289C28.391 17.5064 28.0953 17.206 27.7646 17.2744",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiet);
export default __webpack_public_path__ + "static/media/quiet.7c21d7e7175bbe9bb54c0e2088b0b524.svg";
export { ForwardRef as ReactComponent };